export enum ButtonWidgetActEnum {
  OPTION = "@buttonWidget/OPTION",
}
